import Nav from './Nav.js';
import Header from './Header.js';
import Projects from './Projects.js';
import About from './About.js';
import Footer from './Footer.js';


function App() {
  return (
    <>
      <Nav />
      <Header />
      <Projects />
      <About />
      <Footer />
    </>
  );
}

export default App;
